import { createContext, useContext, useEffect, useState } from "react";
import pt from "./translations/pt";

const LangContext = createContext(null);

// PT va en el bundle principal (idioma por defecto de la marca);
// los demas diccionarios se cargan bajo demanda al cambiar de idioma.
const LOADERS = {
  es: () => import("./translations/es"),
  en: () => import("./translations/en"),
  it: () => import("./translations/it"),
};
const VALID = ["pt", "es", "en", "it"];

const ES_MONTHS = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
const MONTHS = {
  en: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  pt: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
  it: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
};

export function localizeDate(str, lang) {
  if (!str || lang === "es" || !MONTHS[lang]) return str;
  let out = str;
  ES_MONTHS.forEach((m, i) => {
    out = out.replace(new RegExp(m, "gi"), MONTHS[lang][i]);
  });
  return out;
}

// Campos de una salida grupal traducidos: si existe dep.i18n[lang][field] lo usa,
// si no, cae al campo base (espanol, idioma en que se carga desde el admin).
export function depField(dep, field, lang) {
  const v = dep?.i18n?.[lang]?.[field];
  if (v != null && (Array.isArray(v) ? v.length > 0 : v !== "")) return v;
  return dep?.[field];
}

export function depDateLabel(dep, lang) {
  const v = dep?.i18n?.[lang]?.date_label;
  if (v) return v;
  return localizeDate(dep?.date_label, lang);
}


// El idioma por defecto es siempre portugues (mercado principal de la marca).
// Esto garantiza que los prerenders para bots y las tarjetas de WhatsApp salgan
// en PT; el visitante puede cambiar de idioma y su eleccion queda guardada.
export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      const urlLang = new URLSearchParams(window.location.search).get("lang");
      if (urlLang && VALID.includes(urlLang)) return urlLang;
      const saved = localStorage.getItem("wyd_lang");
      if (saved && VALID.includes(saved)) return saved;
      return "pt";
    } catch {
      return "pt";
    }
  });
  const [dicts, setDicts] = useState({ pt });

  useEffect(() => {
    document.documentElement.lang = lang;
    if (!dicts[lang] && LOADERS[lang]) {
      let alive = true;
      LOADERS[lang]().then((m) => {
        if (alive) setDicts((d) => ({ ...d, [lang]: m.default }));
      });
      return () => {
        alive = false;
      };
    }
  }, [lang, dicts]);

  const setLang = (l) => {
    if (!VALID.includes(l)) return;
    try {
      localStorage.setItem("wyd_lang", l);
    } catch {}
    setLangState(l);
  };

  const t = (path) => {
    const get = (obj) => path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), obj);
    return get(dicts[lang]) ?? get(dicts.pt) ?? path;
  };

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
